const SvgDirectory = (props) => (
  <svg height="1em" viewBox="0 0 16 15" width="1em" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M-1-1h18v18H-1z" />
      <path
        d="M14.7 1.667c.867 0 1.3.434 1.3 1.302v10.52c0 .417-.117.773-.35 1.068-.233.295-.55.443-.95.443H1.4c-.4 0-.733-.148-1-.443A1.537 1.537 0 0 1 0 13.49V1.25C0 .417.467 0 1.4 0h3c.333 0 .683.226 1.05.677.567.66.883.99.95.99h8.3zM1.4.833c-.4 0-.6.14-.6.417v2.917h14.4V2.969c0-.313-.167-.469-.5-.469H6.4a.96.96 0 0 1-.45-.104 1.162 1.162 0 0 1-.3-.208 8.783 8.783 0 0 1-.375-.443A6.3 6.3 0 0 1 4.9 1.25C4.667.972 4.417.833 4.15.833H1.4zm13.3 13.334c.333 0 .5-.226.5-.677V5H.8v8.49c0 .173.058.33.175.468a.536.536 0 0 0 .425.209h13.3z"
        fill="currentColor"
      />
    </g>
  </svg>
)

export default SvgDirectory
